<template>
  <div class="charges">
    <header v-if="title" class="charges__header">
      <BaseTitle
        v-bind="title"
        class="charges__name"
      />
    </header>
    <div class="charges__items">
      <div
        v-for="item in items"
        :key="`charges_item_${item.id}`"
        class="charges__item"
      >
        <FieldSum
          v-model="item.value"
          label=""
          class="charges__field"
        />
        <div class="charges__label">
          <BaseTitle
            :text="item.name"
            size="m"
            is-normal
          />
        </div>
      </div>
    </div>
    <footer class="charges__footer">
      <div
        v-if="diffSum !== 0"
        class="charges__diff sum"
        :class="{
          sum_negative: diffSum < 0,
          sum_positive: diffSum > 0,
        }"
      >
        {{ diffLabel }}&ensp;{{ diffSum | sum }}
      </div>
      <BaseButton
        :text="payButtonText"
        class="charges__button"
        :disabled="sum === 0"
        @click="$emit('pay')"
      />
    </footer>
  </div>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import BaseButton from '@/components/BaseButton.vue';
import FieldSum from '@/components/FieldSum.vue';

export default {
  name: 'Charges',
  components: {
    BaseTitle,
    BaseButton,
    FieldSum,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    sum: {
      type: Number,
      default: 0,
    },
    diffSum: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    title() {
      return {
        text: this.$t('titles.payCharges'),
        size: 'm',
      };
    },
    diffLabel() {
      return this.$t(this.diffSum > 0 ? 'titles.positiveBalance' : 'titles.negativeBalance');
    },
    payButtonText() {
      const sum = this.sum > 0 ? this.$options.filters.sum(this.sum, true) : '';
      return this.$t('actions.pay') + sum;
    },
  },
};
</script>

<style lang="stylus">
.charges
  display block

  &__header
    // text-transform capitalize
    padding-bottom 0.5em

  &__items
    padding-bottom 2em

  &__footer
    position sticky
    bottom 0
    display flex
    align-items center
    justify-content flex-end
    padding-top 1em
    background-color #fff
    border-top solid 1px $c_bg

  &__diff
    padding-right 2em

  &__item
    display flex
    align-items center
    margin-top 0.25em
    &:first-child
      margin-top 0

  &__label
  &__field
    flex-grow 1
    flex-basis 0
    max-width 100%

  &__label
    max-width calc(100% - 10em)
    padding 1em 0

  &__field
    max-width 10em
    order 1
    .field__message
      display none
    &.field_focused ~ ^[0]__label
      background-color $c_bg
      padding-left 1em
      border-left solid 3px darken($c_bg, 20%)
</style>
